/** Advisor service — persistent conversation with Lumfi AI. */
import { api } from "../lib/api";

export const advisorService = {
  thread: () => api.get("/advisor/thread").then((r) => r.data),
  send: (message) => api.post("/advisor/message", { message }).then((r) => r.data),
  reset: () => api.post("/advisor/reset").then((r) => r.data),
  executeAction: (action) =>
    api.post("/advisor/execute-action", { action }).then((r) => r.data),
};
